<rid-mechanic-background />

<rid-mechanic-wrapper>
  <rid-top-bar class="block w-full" name="Klankbord" [steps]="0" />

  <rid-mechanic-content>
    <div class="grid justify-items-center gap-16">
      <div class="relative w-full">
        <rid-vertical-spacer>
          <div class="flex gap-4">
            <rid-text-input>
              <div class="flex">
                <rid-vertical-spacer>
                  <rid-compressable-klank-card content="x" />
                </rid-vertical-spacer>
              </div>
            </rid-text-input>
          </div>
        </rid-vertical-spacer>

        @for (v of [version()]; track v) {
          <div class="absolute bottom-0 flex w-full items-center justify-items-center gap-4" animate.leave="anim-fade-out">
            <rid-text-input class="w-full" animate.enter="wait-750 anim-pop-in" ridSfx="BUBBLE_POP">
              <div class="flex place-self-center">
                <rid-vertical-spacer>
                  <rid-compressable-klank-card content="x" />
                </rid-vertical-spacer>

                @for (k of keyboardComp.content(); track $index) {
                  <rid-syllabic-card #syllabicCard [value]="k" animate.enter="anim-pop-in" />
                }
                @for (k of keyboardComp.postfix(); track $index) {
                  <rid-syllabic-card #syllabicCard [value]="k" animate.enter="anim-fade-in" />
                }
              </div>
            </rid-text-input>
            <div class="flex flex-col gap-4">
              <rid-button appearance="DANGER" [disabled]="keyboardComp.isEmpty()" (click)="keyboardComp.pop()">
                <i-backspace class="size-[1lh]" />
              </rid-button>
              <rid-button [disabled]="keyboardComp.isEmpty()" (click)="okay()">
                <i-enter class="size-[1lh]" />
              </rid-button>
            </div>
          </div>
        }
      </div>

      <rid-functional-syllabic-keyboard
        #keyboardComp
        [isDisabled]="isEvaluating()"
        [layout]="layout()"
        [mode]="mode()"
        [mask]="mask()"
        (incorrected)="overlayFeedback.showIncorrect()"
      />

      <!-- feedback overlay -->
      <rid-overlay-feedback #overlayFeedback />
    </div>
  </rid-mechanic-content>
</rid-mechanic-wrapper>
